<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ChartsLine',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: ''
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      let xAxisData = []
      let seriesData = []
      if (this.data) {
        xAxisData = this.data.map((item) => item.name)
        seriesData = this.data.map((item) => item.value)
      }
      const option = {
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        // 工具提示
        tooltip: {
          trigger: 'axis',
          formatter: '{b} <br/>{a} : {c}',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 100) * 100
            },
            max: (value) => {
              // return Math.ceil(value.max / 100) * 100 + 300
              return Math.ceil(value.max)
            }
          }
        ],
        // 颜色配置
        // color: this.color,
        // 类型配置
        series: [
          {
            name: '设备数量',
            // 类型配置
            type: 'line',
            // 圆滑线
            smooth: true,
            symbolSize: 5,
            // 数据配置
            data: seriesData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  color: '#000',
                  position: 'top',
                  formatter: '{c}'
                }
              }
            },
            // 背景渐变
            areaStyle: {
              normal: {
                //右，下，左，上
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#667eea'
                    },
                    {
                      offset: 1,
                      color: '#fff'
                    }
                  ],
                  false
                )
              }
            }
          }
        ]
      }
      mychart.setOption(option)
    }
  }
}
</script>

<style lang="less"></style>
